"use client";

import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
        font-family: "DM Sans", sans-serif;
    }

    /* Reset buttons */
    button {
        background-color: transparent;
        border: none;
        cursor: pointer;
        outline: none;
        padding: 0;
        margin: 0;
        box-shadow: none;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    ul, li {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    input {
        border: none;
        outline: none;
        width: 100%;
        display: block;
        background: none;
        /* Chrome, Safari, Edge, Opera */

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
            -webkit-background-clip: text;
            -webkit-text-fill-color: #ffffff;
            transition: background-color 5000s ease-in-out 0s;
            box-shadow: inset 0 0 20px 20px #23232329;
        }

        /* Firefox */

        &[type=number] {
            -moz-appearance: textfield;
        }
    }

    p, h1, h2, h3, h4, h5, h6 {
        margin: 0;
    }

    * {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
    }
`;

export default GlobalStyles;
